/* Vantura Outfitters 2.0 — global behaviour (no dependencies) */
(function () {
  'use strict';
  var VO = window.VO = window.VO || {};
  VO.routes = VO.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  VO.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || VO.moneyFormat || '${{amount}}';
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  /* ---------- Overlays (drawers, search, modals) ---------- */
  var lastFocus = null;
  var FOCUSABLE = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openOverlay(el, opener) {
    if (!el) return;
    closeAll();
    lastFocus = opener || document.activeElement;
    el.classList.add('is-open');
    document.body.classList.add('vo-lock');
    document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () {
      var panel = el.querySelector('.vo-drawer__panel, .vo-search__panel') || el;
      var target = el.querySelector('[data-vo-search-input]') || panel.querySelector(FOCUSABLE);
      if (target) target.focus({ preventScroll: true });
    }, reduceMotion ? 0 : 60);
  }
  function closeOverlay(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!document.querySelector('.vo-drawer.is-open, .vo-search.is-open')) document.body.classList.remove('vo-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  function closeAll() {
    document.querySelectorAll('.vo-drawer.is-open, .vo-search.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.body.classList.remove('vo-lock');
  }
  VO.openOverlay = openOverlay;
  VO.closeOverlay = closeOverlay;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vo-open]');
    if (opener) {
      e.preventDefault();
      openOverlay(document.getElementById(opener.getAttribute('data-vo-open')), opener);
      return;
    }
    var closer = e.target.closest('[data-vo-close]');
    if (closer) {
      e.preventDefault();
      closeOverlay(closer.closest('.vo-drawer, .vo-search'));
    }
  });

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.vo-drawer.is-open, .vo-search.is-open');
    if (e.key === 'Escape') {
      if (open) closeOverlay(open);
      closeMegas();
      return;
    }
    if (e.key === 'Tab' && open) {
      var items = Array.prototype.filter.call(open.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header ---------- */
  var header = document.querySelector('[data-vo-header]');
  if (header && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
    document.body.prepend(sentinel);
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  function closeMegas(except) {
    document.querySelectorAll('[data-vo-mega].is-open').forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var a = li.querySelector('.vo-nav__link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  // Desktop: each parent label is a disclosure button. Hover opens on mouse devices;
  // click/tap/Enter/Space toggles; Escape or a click outside closes.
  var canHover = window.matchMedia('(hover: hover)');
  document.querySelectorAll('[data-vo-mega]').forEach(function (li) {
    var btn = li.querySelector('.vo-nav__link');
    var timer, openedAt = 0;
    function open() { clearTimeout(timer); closeMegas(li); if (!li.classList.contains('is-open')) openedAt = Date.now(); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function shut() { clearTimeout(timer); li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    li.addEventListener('mouseenter', function () { if (canHover.matches) open(); });
    li.addEventListener('mouseleave', function () { if (canHover.matches) timer = setTimeout(shut, 120); });
    li.addEventListener('focusout', function (e) { if (e.relatedTarget && !li.contains(e.relatedTarget)) shut(); });
    btn.addEventListener('click', function () {
      // A click straight after hover-opening keeps the panel open instead of toggling it shut.
      if (li.classList.contains('is-open') && Date.now() - openedAt > 400) shut(); else open();
    });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && li.classList.contains('is-open')) { shut(); btn.focus(); }
      if (e.key === 'ArrowDown' && e.target === btn) { e.preventDefault(); open(); var f = li.querySelector('.vo-mega a'); if (f) setTimeout(function () { f.focus(); }, 30); }
    });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-vo-mega]')) closeMegas(); });

  // Mobile drawer: the whole parent row is the accordion trigger.
  document.querySelectorAll('.vo-mnav__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.hidden = expanded;
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = document.querySelector('[data-vo-search-input]');
  var searchResults = document.querySelector('[data-vo-search-results]');
  if (searchInput && searchResults) {
    var searchTimer, controller;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = VO.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          var items = [].concat(
            (res.products || []).map(function (p) { return { url: p.url, title: p.title, img: p.featured_image && p.featured_image.url, meta: p.price ? VO.formatMoney(Math.round(parseFloat(p.price) * 100)) : '' }; }),
            (res.articles || []).map(function (a) { return { url: a.url, title: a.title, img: a.featured_image && a.featured_image.url, meta: 'Guide' }; }),
            (res.pages || []).map(function (pg) { return { url: pg.url, title: pg.title, img: null, meta: 'Page' }; })
          );
          if (!items.length) {
            searchResults.innerHTML = '<p class="vo-muted">No results for “' + escapeHtml(q) + '”.</p>';
            return;
          }
          searchResults.innerHTML = '<p class="vo-label" style="margin-bottom:14px">Suggestions</p><div class="vo-search__grid">' + items.map(function (it) {
            var img = it.img ? '<img src="' + it.img + (it.img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="64" height="64">' : '<img alt="" width="64" height="64">';
            return '<a class="vo-search__item" href="' + it.url + '">' + img + '<span>' + escapeHtml(it.title) + (it.meta ? '<small>' + escapeHtml(it.meta) + '</small>' : '') + '</span></a>';
          }).join('') + '</div><p style="margin-top:18px"><a class="vo-link-arrow" href="' + VO.routes.search + '?q=' + encodeURIComponent(q) + '">View all results</a></p>';
        }).catch(function () {});
      }, 220);
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  VO.escapeHtml = escapeHtml;

  /* ---------- Cart ---------- */
  var drawer = document.querySelector('[data-vo-cart-drawer]');

  function updateCount(count) {
    document.querySelectorAll('[data-vo-cart-count]').forEach(function (el) {
      el.setAttribute('data-count', count);
      el.textContent = count > 0 ? count : '';
    });
    document.querySelectorAll('[data-vo-cart-count-text]').forEach(function (el) { el.textContent = count; });
  }
  function renderDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-vo-cart-inner]');
    var current = drawer.querySelector('[data-vo-cart-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function refreshCart(open) {
    return fetch(VO.routes.root + '?sections=vo-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderDrawer(data['vo-cart-drawer']);
        return fetch(VO.routes.cart + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (open && drawer) openOverlay(drawer);
        document.dispatchEvent(new CustomEvent('vo:cart:updated', { detail: cart }));
        return cart;
      });
  }
  VO.refreshCart = refreshCart;

  VO.addToCart = function (formData) {
    formData.append('sections', 'vo-cart-drawer');
    formData.append('sections_url', window.location.pathname);
    return fetch(VO.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) { var err = new Error(json.description || json.message || 'Could not add to cart'); throw err; }
        return json;
      });
    }).then(function (json) {
      if (VO.cartType === 'page') { window.location.href = VO.routes.cart; return json; }
      if (json.sections && json.sections['vo-cart-drawer']) renderDrawer(json.sections['vo-cart-drawer']);
      return fetch(VO.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        updateCount(cart.item_count);
        if (drawer) openOverlay(drawer);
        document.dispatchEvent(new CustomEvent('vo:cart:updated', { detail: cart }));
        return json;
      });
    });
  };

  function changeLine(line, quantity) {
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    return fetch(VO.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['vo-cart-drawer'] }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.sections && cart.sections['vo-cart-drawer']) renderDrawer(cart.sections['vo-cart-drawer']);
      if (typeof cart.item_count === 'number') updateCount(cart.item_count);
      if (drawer) drawer.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('vo:cart:updated', { detail: cart }));
      var focusTarget = drawer && drawer.querySelector('[data-vo-line-input="' + line + '"]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var step = e.target.closest('[data-vo-qty]');
      if (step) {
        var wrap = step.closest('[data-vo-line]');
        var input = wrap.querySelector('input');
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-vo-qty'), 10));
        input.value = next;
        changeLine(parseInt(wrap.getAttribute('data-vo-line'), 10), next);
        return;
      }
      var rm = e.target.closest('[data-vo-remove]');
      if (rm) changeLine(parseInt(rm.getAttribute('data-vo-remove'), 10), 0);
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-vo-line-input]');
      if (input) changeLine(parseInt(input.getAttribute('data-vo-line-input'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  document.querySelectorAll('[data-vo-cart-toggle]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer || VO.cartType === 'page' || document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      openOverlay(drawer, a);
    });
  });

  // Keep the drawer fresh when returning via back/forward cache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(false); });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.vo-reveal');
  if (revealEls.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Autoplay videos only when visible / motion allowed ---------- */
  document.querySelectorAll('video[data-vo-autoplay]').forEach(function (v) {
    if (reduceMotion) { v.removeAttribute('autoplay'); v.pause(); return; }
    if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) v.play().catch(function () {}); else v.pause(); });
    }, { threshold: 0.2 }).observe(v);
  });

  /* ---------- Contact form prefill (?topic=...) ---------- */
  var topic = new URLSearchParams(window.location.search).get('topic');
  var msg = document.querySelector('[data-vo-contact-message]');
  if (topic && msg && !msg.value) {
    var topics = {
      'bootlid-fitment': 'Bootlid table fitment check\nVehicle make / model / year:\n\nPlease reply to this email with a clear photo of the open rear door/tailgate and the latch/mounting area.',
      'ladder-fitment': 'Ladder Steps V4 fitment check\nLadder brand / model:\nRung width and depth (mm):\n\nPlease reply to this email with a clear photo of a ladder rung.',
      'rtt-setup': 'Rooftop tent setup check\nVehicle make / model / year:\nRoof rack or platform:\n'
    };
    if (topics[topic]) msg.value = topics[topic];
  }

  /* ---------- Shopify theme editor ---------- */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.vo-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
